
import React from 'react';
import axios from "axios";

import {Grid, Box, Button, Link, InputLabel,OutlinedInput} from '@material-ui/core';
import DehazeIcon from '@material-ui/icons/Dehaze';
import CloseIcon from '@material-ui/icons/Close';
import ReactHtmlParser from "react-html-parser";


class Login extends React.Component{
    
    constructor(props){
        super(props);

        this.ChangeUserRole = this.ChangeUserRole.bind(this);
        this.OpenPage = this.OpenPage.bind(this);
        this.handleSignIn = this.handleSignIn.bind(this);
        this.handleLoginLSigninChange = this.handleLoginLSigninChange.bind(this);
        this.handlePassSgininChange = this.handlePassSgininChange.bind(this);
        this.redirectToCabinet = this.redirectToCabinet.bind(this);
        //this.signinWithGoogle = this.signinWithGoogle.bind(this);
        this.ShowHidePass = this.ShowHidePass.bind(this);
        this.CheckAuthProvidersVisibility = this.CheckAuthProvidersVisibility.bind(this);

       // this.signinWithFacebook = this.signinWithFacebook.bind(this);

        this.handleClick = this.handleClick.bind(this);

        this.userRoleStatements = {Seller:"Seller", Investor:"Investor"};

        this.objStateLogin= {
            Login:"",
            Pass:""
        };

        this.state = {
            IsAuthUser:'',
            EmailPassRecover:'',

            LoginStateError:false,
            PassStateError:false,
            PassMsgError:"",
            LoginMsgError: "",
            click: false,
            IsHidePass:false,
            ShowGoogleProvider:false,
            ShowFacebookProvider:false,

            UserRole: sessionStorage["UserRole"] != undefined && sessionStorage["UserRole"] != null ? sessionStorage["UserRole"] : this.userRoleStatements.Seller
        }

        this.CheckAuthProvidersVisibility();
    }

    CheckAuthProvidersVisibility(){
         
        axios
        .get("Home/AuthProvidersVisibility", { withCredentials: true })
        .then(response =>{ 
            this.setState({ShowGoogleProvider:response.data.ShowGoogle, ShowFacebookProvider: response.data.ShowFacebook});
        })
        .catch(error => {
          console.log("check login error", error);
        });

        
    }

    handleClick() {
        if (this.state.click == false) {
            this.setState({ click: true });
        } else {
            this.setState({ click: false });
        }
    } 

    /*signinWithGoogle(){

        let xhr = new XMLHttpRequest();

        xhr.open("GET", "/acl.cn?provider=Google&&selectedRole=" + this.state.UserRole);

        xhr.responseType = 'json';

        xhr.send();

        xhr.onload = function() {
          let responseObj = xhr.response;
          alert(responseObj.message);
        };

    }*/

  /*  signinWithFacebook(){

        let xhr = new XMLHttpRequest();

        xhr.open("GET", "/acl.cn?provider=Facebook&&selectedRole=" + this.state.UserRole);

        xhr.responseType = 'json';

        xhr.send();

        xhr.onload = function() {
          let responseObj = xhr.response;
          alert(responseObj.message);
        };

    }*/


    componentDidMount(){
        axios
        .get("Account/CheckLogin", { withCredentials: true })
        .then(response => {
            this.setState({IsAuthUser : response.data.IsAuthenticated});

            if(response.data.IsAuthenticated == true){
                 this.redirectToCabinet(); 
            }          
        })
        .catch(error => {
          console.log("check login error", error);
        });
    }


       ChangeUserRole(role){    

        if(role == this.userRoleStatements.Seller){
            document.getElementById('button-sell').setAttribute("style", "background: #529ED0;color: #FFFFFF;");
            document.getElementById('button-buy').setAttribute("style", "background: #ECF4F8;color:#7E96AE;");

            this.setState({UserRole: this.userRoleStatements.Seller});
            
            sessionStorage["UserRole"] = this.userRoleStatements.Seller;

        }else if(role == this.userRoleStatements.Investor){
            document.getElementById('button-sell').setAttribute("style", "background: #ECF4F8;color: #7E96AE;");
            document.getElementById('button-buy').setAttribute("style", "background: #529ED0;color:#FFFFFF;");

            this.setState({UserRole: this.userRoleStatements.Investor});

            sessionStorage["UserRole"] = this.userRoleStatements.Investor;

        }

      };

      

      OpenPage(page){

         if(page == "login"){
            window.location.href = '/login';
         }else if(page == "register") {         
            window.location.href = '/register';
         } else if(page =="forgotpassword"){
            window.location.href = '/forgotpass';
         }
      };

      handleSubmit(){
        var passwordRegex=/^(?=.*[a-zA-Z])(?=.*[0-9])(^[A-Za-z0-9 ]+$)/;
        var phoneRegex =/^\+?3?8?(0\d{9})$/;
        var isFormValid;

        if(this.objStateLogin.Login.trim().length == 0){

            this.setState({LoginStateError:true});
            this.setState({LoginMsgError:"<div style='color:#f44336' >Поле <strong>логін</strong> обов'язкове до заповнення</div>"});

            isFormValid=false;

        }else if(this.objStateLogin.Login.match(phoneRegex)){
            if(this.objStateLogin.Login.startsWith("+380") == false){
                this.setState({LoginStateError:true});
                this.setState({LoginMsgError:"<div style='color:#f44336' >Введений телефон некоректний у відповідності до формату +380(XX)-XXX-XX-XX</div>"});

                isFormValid=false;
            }else {
                this.setState({LoginStateError:false});
                this.setState({LoginMsgError:""});
            }

        }
        else{
            this.setState({LoginStateError:false});
            this.setState({LoginMsgError:""});
        }


        if(this.objStateLogin.Pass.trim().length == 0){
            this.setState({PassStateError:true});
            this.setState({PassMsgError:"<div style='color:#f44336' >Поле <strong>пароль</strong> обов'язкове до заповнення</div>"});

            isFormValid=false;
        }
        else {
            this.setState({PassStateError:false});
            this.setState({PassMsgError:""});
        }


        if(isFormValid != false){
            this.handleSignIn();
        }

      }


       handleSignIn(){
    
                    var xmlhttp = new XMLHttpRequest(); 
                        
                    xmlhttp.open("POST", "Account/Login");
                    xmlhttp.setRequestHeader("Content-Type", "application/json");
                    xmlhttp.send(JSON.stringify({"UserName":this.objStateLogin.Login,"Password" : this.objStateLogin.Pass, "UserRole": this.state.UserRole}));

                    xmlhttp.onreadystatechange = () => {
                
                if (xmlhttp.readyState == XMLHttpRequest.DONE) {
                    
                    var response = JSON.parse(xmlhttp.responseText);

                    if(response.isSucceed == true){
                    
                      this.redirectToCabinet();

                    }else if(response.isSucceed == false && response.status == 'noconfirmation'){
                        
                        this.setState({LoginStateError:true});
                        this.setState({LoginMsgError:"<div style='color:#f44336' >"+response.msg+"</div>"});

                    }else if(response.isSucceed == false){
                        alert(response.msg);
                    }

                }

                    }
       }        

      redirectToCabinet(){
        window.location.href = '/cabinet';
      };


         handleLoginLSigninChange (e){
            this.objStateLogin.Login = e.target.value;
        }

         handlePassSgininChange (e){
            this.objStateLogin.Pass = e.target.value;
        }

        ShowHidePass(){
            if(this.state.IsHidePass == false){
                document.getElementById("password-inpt").type="text";
                this.setState({IsHidePass:true});
            }else if(this.state.IsHidePass == true){
                document.getElementById("password-inpt").type="password";
                this.setState({IsHidePass:false});
            }
        }



        render(){
      
    return (

        <Grid id="loginLayout" >

    {this.state.IsAuthUser == false ? 

         <Grid container className="landingPage" >
            <Grid container className="headerLogin">
                <Grid item wrap="nowrap" className="titlelogo">
                    <Box className="logo">
                        <svg width="196" height="39" viewBox="0 0 196 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0)">
                                <path d="M68.3748 30.544V11.1572H72.5185V26.8025H81.5006V30.544H68.3748Z" fill="#328C45" />
                                <path d="M89.9219 29.1598C89.9219 29.1598 88.5407 30.8208 86.1884 30.8208C83.4259 30.8208 81.6262 29.0172 81.6262 26.9451C81.6262 24.7304 83.1497 23.1785 85.6359 22.7339L89.9219 21.9621C89.9219 20.8548 89.0931 20.0243 87.5696 20.0243C85.4936 20.0243 84.5309 21.4084 84.5309 21.4084L82.4549 19.328C82.4549 19.328 84.2547 16.7023 87.8459 16.7023C91.3031 16.7023 93.647 19.0512 93.647 22.1047V30.5523C93.647 30.5523 90.7422 30.5523 89.9135 30.5523V29.1598H89.9219ZM89.9219 24.7304V24.311L86.8832 24.8647C85.9121 25.0324 85.3597 25.561 85.3597 26.3831C85.3597 27.2136 85.9121 27.7672 87.1594 27.7672C88.8169 27.7756 89.9219 26.6599 89.9219 24.7304Z" fill="#328C45" />
                                <path d="M99.5905 18.6317C99.5905 18.6317 100.972 16.6938 103.458 16.6938C106.497 16.6938 108.707 18.9085 108.707 22.65V30.5439H104.973V23.0694C104.973 21.4084 103.868 20.3011 102.345 20.3011C100.687 20.3011 99.5821 21.4084 99.5821 23.4889V30.5523H95.8486V16.9707H99.5821V18.6317H99.5905Z" fill="#328C45" />
                                <path d="M120.585 11.1572V18.6317V23.7406V23.749C120.585 25.9636 119.062 27.4904 117.27 27.4904C115.479 27.4904 113.955 25.972 113.955 23.749C113.955 21.5259 115.479 20.0075 117.27 20.0075C117.58 20.0075 117.881 20.0662 118.166 20.1585V16.954C117.697 16.7946 117.17 16.6939 116.575 16.6939C113.126 16.6939 110.079 19.7391 110.079 23.7574C110.079 27.7756 113.118 30.8208 116.575 30.8208C119.204 30.8208 120.585 28.883 120.585 28.883V30.544H124.319V11.1572H120.585Z" fill="#328C45" />
                                <path d="M2.47783 14.689C16.5412 6.61047 32.7141 2.63413 49.0209 3.36397C49.0209 3.36397 49.0209 3.36397 49.0209 3.35558C32.9569 -1.28348 15.8799 -1.09054 0 3.7918C0 3.83375 0 3.88408 0 3.92602C0 7.78492 0.895703 11.4425 2.47783 14.689Z" fill="#E47F26" />
                                <path d="M57.4422 5.22632C38.4734 4.37904 19.6469 9.00133 3.28146 18.4053C4.99753 21.9202 7.4084 25.0241 10.3299 27.5492C23.7403 16.1571 40.0137 8.43927 57.4422 5.32699C57.4422 5.29343 57.4422 5.25988 57.4422 5.22632Z" fill="#328C45" />
                                <path d="M65.7128 5.71281C65.7128 5.59536 65.7044 5.47792 65.7044 5.36047C45.865 8.90059 27.3398 17.6838 12.0794 30.6446C16.0808 34.1008 20.936 36.5924 26.2767 37.7584C36.7908 24.311 50.2682 13.3048 65.7128 5.71281Z" fill="#529ED0" />
                                <path d="M30.1777 38.4715C32.0445 38.8491 33.9698 39.0336 35.9537 39.0001C50.7873 38.7316 62.5988 26.467 62.3393 11.6019C62.3393 11.5264 62.3309 11.4593 62.3309 11.3838C49.6655 17.8852 38.6827 27.1885 30.1777 38.4715Z" fill="#3867B1" />
                                <path d="M127.491 11.1572H131.635V30.5356H127.491V11.1572Z" fill="#3F4E5D" />
                                <path d="M138.123 18.6317C138.123 18.6317 139.504 16.6938 141.99 16.6938C145.029 16.6938 147.239 18.9085 147.239 22.65V30.5439H143.505V23.0694C143.505 21.4084 142.4 20.3011 140.877 20.3011C139.219 20.3011 138.114 21.4084 138.114 23.4889V30.5523H134.381V16.9707H138.123V18.6317Z" fill="#3F4E5D" />
                                <path d="M152.906 30.544L147.791 16.9791H151.659L154.831 25.9804L158.012 16.9791H161.88L156.765 30.544H152.906Z" fill="#3F4E5D" />
                                <path d="M165.471 25.0072C165.747 26.3914 166.994 27.633 169.062 27.633C171.414 27.633 172.653 25.972 172.653 25.972L174.587 28.4635C174.587 28.4635 172.519 30.8208 168.786 30.8208C164.776 30.8208 161.603 27.633 161.603 23.7573C161.603 19.8816 164.784 16.6938 168.652 16.6938C172.519 16.6938 175.424 19.5964 175.424 23.4805C175.424 24.4536 175.282 25.0072 175.282 25.0072H165.471ZM165.471 22.3731H171.69C171.414 20.989 170.309 19.8816 168.652 19.8816C166.994 19.8816 165.881 20.989 165.471 22.3731Z" fill="#3F4E5D" />
                                <path d="M184.255 20.989C184.255 20.989 183.427 19.8816 182.045 19.8816C180.94 19.8816 180.388 20.4353 180.388 20.989C180.388 22.9268 186.608 21.9621 186.608 26.5256C186.608 28.8829 184.674 30.8208 181.217 30.8208C177.349 30.8208 175.692 28.3293 175.692 28.3293L177.768 26.2488C177.768 26.2488 178.873 27.7756 180.664 27.7756C181.912 27.7756 182.464 27.2219 182.464 26.5256C182.464 24.4536 176.244 25.477 176.244 20.989C176.244 18.9085 178.454 16.6938 181.493 16.6938C184.674 16.6938 186.189 18.7659 186.189 18.7659L184.255 20.989Z" fill="#3F4E5D" />
                                <path d="M189.638 12.9608H192.953V17.2559H195.715V20.5779H192.953V25.9804C192.953 26.8109 193.648 27.4988 194.61 27.4988C195.439 27.4988 195.992 27.2219 195.992 27.2219V30.4097C195.992 30.4097 194.887 30.8292 193.505 30.8292C190.743 30.8292 189.219 29.3024 189.219 26.123V20.5863H186.867V17.2643H188.114C188.943 17.2643 189.638 16.568 189.638 15.4607V12.9608Z" fill="#3F4E5D" />
                            </g>
                            <defs>
                                <clipPath id="clip0">
                                    <rect width="196" height="39" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </Box>
                </Grid>
                    <Grid item wrap="nowrap" className="Mob-Icon" onClick={() => this.handleClick()}>
                        {this.state.click ? <CloseIcon /> : <DehazeIcon />}
                    </Grid>
                    <div container className={this.state.click ? 'MobMenu active' : 'MobMenu'}>
                    <Grid container item direction="row" justify="flex-end" alignItems="baseline" className="menu">
                        <Box className="listitems">
                            <Box className="item">
                            <Link target="_blank" href="https://land-invest.com.ua/">Про нас</Link>
                            </Box>
                            {/*
                            
                                <Box className="item">
                                Купити
                            </Box>
                            <Box className="item">
                                Ціни
                            </Box>
                            <Box className="item">
                                Контакти
                            </Box>

                            */}
                        </Box>
                    </Grid>
                    <Grid container item justify="flex-end" alignItems="center" className="profile">
                        <Box className="logo logo--Wibe">
                            <Box component="span" className="txt" >Ми у </Box>
                            <a href="https://chats.viber.com/landinvest" target="_blank" >
                                <svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.5597 0.200073H9.43974C4.49894 0.200073 0.479736 4.21927 0.479736 9.16007V13.0001C0.479736 16.4721 2.47974 19.6177 5.59974 21.0993V25.3777C5.59974 25.7489 6.06374 25.9409 6.32614 25.6785L10.0445 21.9633H14.5597C19.5005 21.9633 23.5197 17.9441 23.5197 13.0001V9.16007C23.5197 4.21927 19.5005 0.200073 14.5597 0.200073ZM17.9133 16.994L16.6173 18.2612C15.2541 19.5956 11.6957 18.0724 8.55974 14.8692C5.42374 11.6628 4.04774 8.07239 5.34374 6.73799L6.63974 5.47079C7.11654 5.00359 7.92614 5.01319 8.46054 5.48999L10.3293 7.40039C10.9949 8.08199 10.7133 9.22439 9.83333 9.48679C9.22534 9.68199 8.81254 10.3508 9.00774 10.9588C9.33094 12.3796 11.1325 14.1556 12.4765 14.5076C13.0813 14.6484 13.7597 14.3188 13.9709 13.714C14.2493 12.8404 15.3981 12.5812 16.0669 13.266L17.9325 15.1732C18.3997 15.6497 18.3933 16.4596 17.9133 16.994ZM13.1645 6.28007C13.0365 6.28007 12.9085 6.28647 12.7837 6.30247C12.5501 6.32807 12.3389 6.15847 12.3133 5.92487C12.2877 5.69127 12.4573 5.48007 12.6909 5.45447C12.8477 5.43527 13.0077 5.42887 13.1645 5.42887C15.5165 5.42887 17.4301 7.34247 17.4301 9.69447C17.4301 9.85127 17.4237 10.0113 17.4045 10.1681C17.3789 10.3985 17.1645 10.5713 16.9341 10.5457C16.7037 10.5201 16.5309 10.3057 16.5565 10.0753C16.5693 9.95047 16.5789 9.82247 16.5789 9.69447C16.5789 7.81287 15.0461 6.28007 13.1645 6.28007ZM15.7245 9.69447C15.7245 9.92807 15.5293 10.1201 15.2957 10.1201C15.0653 10.1201 14.8701 9.92807 14.8701 9.69447C14.8701 8.75367 14.1053 7.98887 13.1645 7.98887C12.9277 7.98887 12.7357 7.79687 12.7357 7.56007C12.7357 7.32647 12.9277 7.13447 13.1645 7.13447C14.5757 7.13447 15.7245 8.28327 15.7245 9.69447ZM18.9789 11.0737C18.9245 11.3041 18.6781 11.4481 18.4509 11.3873C18.2301 11.3265 18.0957 11.0961 18.1469 10.8753C18.2397 10.4913 18.2845 10.0945 18.2845 9.69447C18.2845 6.87207 15.9869 4.57447 13.1645 4.57447C13.0333 4.57447 12.8989 4.57767 12.7677 4.59047C12.5341 4.60647 12.3293 4.43047 12.3101 4.19687C12.2941 3.96007 12.4701 3.75527 12.7037 3.73927C12.8573 3.72647 13.0109 3.72007 13.1645 3.72007C16.4573 3.72007 19.1389 6.40167 19.1389 9.69447C19.1389 10.1585 19.0845 10.6225 18.9789 11.0737Z" fill="#665CAC" />
                                </svg>
                            </a>
                            
                        </Box>
                        <Box className="signin">
                            <Button onClick={() => this.OpenPage('login')}>Увійти</Button>
                        </Box>
                    </Grid>
                </div>
            </Grid>
            <Grid container className="loginpage"  justify="center"  >
                        <Grid container item xl={5} id="loginform" className="loginform" wrap="wrap" justify="center">
                        <Grid className="contentblock">
                            <Box className="title-1">Введіть, будь ласка, Ваш логін та пароль</Box>
                            <Box className="title-2"></Box>
                       
                            {
                                this.state.UserRole == this.userRoleStatements.Seller ?
                                <Box className="buttons">
                                    <Button id="button-sell" onClick={() => this.ChangeUserRole(this.userRoleStatements.Seller)}  className="sell active">Я продаю</Button>
                                    <Button id="button-buy"  onClick={() =>this.ChangeUserRole(this.userRoleStatements.Investor)} className="buy unactive">Я купую</Button>
                                </Box>

                                :

                                null
                            }

                            {
                                this.state.UserRole == this.userRoleStatements.Investor ?
                                <Box className="buttons">
                                    <Button id="button-sell" onClick={() => this.ChangeUserRole(this.userRoleStatements.Seller)}  className="sell unactive">Я продаю</Button>
                                    <Button id="button-buy"  onClick={() =>this.ChangeUserRole(this.userRoleStatements.Investor)} className="buy active">Я купую</Button>
                                </Box>

                                :

                                null
                            }

                            <Box className="inputs">
                                <InputLabel className="text-label" ><Box component="span" className="title" >Email або телефон</Box><Box component="span" className="required" >*</Box></InputLabel >
                                <Box>{ReactHtmlParser(this.state.LoginMsgError)}</Box>
                                <OutlinedInput error={this.state.LoginStateError} onChange={this.handleLoginLSigninChange}  placeholder="Ваш логін" />
                                <InputLabel className="text-label" ><Box component="span" className="title" >Пароль</Box><Box component="span" className="required" >*</Box></InputLabel >
                                <Box>{ReactHtmlParser(this.state.PassMsgError)}</Box>
                                <Box  className="wrapper-pass" >                           
                                                                 
                                    <OutlinedInput  inputProps={{id:"password-inpt"}} className="password-inpt" error={this.state.PassStateError} onChange={this.handlePassSgininChange}  type="password" placeholder="Ваш пароль" />
                                                                       
                                   
                                     <Box component="span" className="show-pass-icon" onClick={()=>this.ShowHidePass()} >

                                        {this.state.IsHidePass == false ? 
                                           <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                           <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82368 13.2956C7.52847 13.446 8.2603 13.5211 9.01919 13.5211C11.0405 13.5211 12.8571 12.9878 14.4691 11.9211C16.1066 10.8302 17.2836 9.42416 18 7.70295C17.5667 6.66191 16.9649 5.74059 16.1946 4.939L13.0874 7.70988C13.0857 8.77361 12.6891 9.69251 11.8977 10.4666C11.1045 11.2181 10.145 11.5939 9.01919 11.5939C8.92532 11.5939 8.83251 11.5912 8.74078 11.586L6.82368 13.2956ZM11.0246 6.36126L7.45769 9.54208C7.38804 9.49068 7.32005 9.43521 7.25373 9.37568C6.79318 8.91507 6.5629 8.35749 6.5629 7.70295C6.5629 7.0484 6.79318 6.50295 7.25373 6.06658C7.73987 5.60598 8.31557 5.37567 8.98081 5.37567C9.67164 5.37567 10.2601 5.60598 10.7463 6.06658C10.8501 6.15983 10.9429 6.25805 11.0246 6.36126ZM12.2103 5.3039C12.114 5.19134 12.0098 5.08193 11.8977 4.97567C11.1045 4.19992 10.145 3.81204 9.01919 3.81204C7.89339 3.81204 6.92111 4.19992 6.10235 4.97567C5.30917 5.72719 4.91258 6.63628 4.91258 7.70295C4.91258 8.76961 5.30917 9.69083 6.10235 10.4666C6.15524 10.5151 6.20877 10.5621 6.26294 10.6075L4.28777 12.3689C4.03109 12.2319 3.7788 12.0826 3.53092 11.9211C1.89339 10.8302 0.716418 9.42416 0 7.70295C0.716418 5.98174 1.89339 4.5878 3.53092 3.52113C5.16844 2.43022 6.99787 1.88477 9.01919 1.88477C10.9785 1.88477 12.7456 2.39729 14.3203 3.42234L12.2103 5.3039Z" fill="#7E96AE"/>
                                           <rect width="22.038" height="1.8238" transform="matrix(0.746436 -0.665457 0.682916 0.730497 0.306641 14.6675)" fill="#7E96AE"/>
                                           </svg>
   
                                        :
                                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.53092 3.818C5.16844 2.7271 6.99787 2.18164 9.01919 2.18164C11.0405 2.18164 12.8571 2.7271 14.4691 3.818C16.1066 4.88467 17.2836 6.27861 18 7.99982C17.2836 9.72104 16.1066 11.1271 14.4691 12.218C12.8571 13.2847 11.0405 13.818 9.01919 13.818C6.99787 13.818 5.16844 13.2847 3.53092 12.218C1.89339 11.1271 0.716418 9.72104 0 7.99982C0.716418 6.27861 1.89339 4.88467 3.53092 3.818ZM6.10235 10.7635C6.92111 11.515 7.89339 11.8907 9.01919 11.8907C10.145 11.8907 11.1045 11.515 11.8977 10.7635C12.6908 9.9877 13.0874 9.06649 13.0874 7.99982C13.0874 6.93316 12.6908 6.02407 11.8977 5.27255C11.1045 4.49679 10.145 4.10891 9.01919 4.10891C7.89339 4.10891 6.92111 4.49679 6.10235 5.27255C5.30917 6.02407 4.91258 6.93316 4.91258 7.99982C4.91258 9.06649 5.30917 9.9877 6.10235 10.7635ZM7.25373 6.36346C7.73987 5.90285 8.31557 5.67255 8.98081 5.67255C9.67164 5.67255 10.2601 5.90285 10.7463 6.36346C11.2324 6.79982 11.4755 7.34528 11.4755 7.99982C11.4755 8.65437 11.2324 9.21194 10.7463 9.67255C10.2601 10.1089 9.67164 10.3271 8.98081 10.3271C8.31557 10.3271 7.73987 10.1089 7.25373 9.67255C6.79318 9.21194 6.5629 8.65437 6.5629 7.99982C6.5629 7.34528 6.79318 6.79982 7.25373 6.36346Z" fill="#7E96AE"/>
                                            </svg>
                                        }

                                     
                                   

                                    </Box> 
                                   
                                </Box>
                        
                            </Box>

                            <Box className="links">
                                <Box><Link onClick={()=> this.OpenPage("forgotpassword")} >Забули пароль?</Link></Box>
                                <Box><Link onClick={()=> this.OpenPage("register")} >Зареєструватися</Link></Box>
                            </Box>
                            {this.state.ShowGoogleProvider == false && this.state.ShowFacebookProvider == false ? null :
                            
                            <Box className="separator">
                                <Box className="item-1"><Box className="text"></Box></Box>
                                <Box className="item-2" >Або</Box>
                                <Box className="item-3" ><Box className="text" ></Box></Box>
                           </Box>

                            }
                        
                            <Box className="signButtons">
                                {this.state.ShowGoogleProvider == true?  <Box className="googleSignIn"><a href={"/acl.cn?provider=Google&&selectedRole=" + this.state.UserRole}><span className="icon" ></span> <span className="buttonText">Увійти через Google</span></a> </Box> : null}
                                {this.state.ShowFacebookProvider == true ? <Box className="facebookSignIn"><a href={"/acl.cn?provider=Facebook&&selectedRole=" + this.state.UserRole}><span className="icon" ></span> <span className="buttonText">Увійти через Facebook</span></a> </Box> : null}                  
                            </Box>
                            <Box className="signin">
                                <Button  onClick={()=> this.handleSubmit()} >
                                    УВІЙТИ
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>    
                </Grid>   
            </Grid>
            : 
            null
            }
        </Grid>


            );
                }
}

export default Login;
